import { useEffect, useState } from 'react';
import { AlertType, IParameters } from '../interface/parameters';
import { CustomerIdentificationStatus } from '../interface/matter';
import { useTranslation } from 'react-i18next';

interface IUseGetMatterCustomerIdentificaitonRestriction {
  matterId: string | undefined;
  matterCustomerIdentificationStatus: CustomerIdentificationStatus | undefined;
  customerIdentificationParametersAlertType: string | undefined;
  setFetchMatter?: (fetch: boolean) => void;
  parameters?: IParameters;
}

export interface ICustomerIdentificationRestrictionObject {
  matterId: string;
  customerIdentificationRestrictionType: AlertType;
  message?: string;
}

export function useGetMatterCustomerIdentificationRestriction({
  matterId,
  matterCustomerIdentificationStatus,
  customerIdentificationParametersAlertType,
  setFetchMatter,
  parameters,
}: IUseGetMatterCustomerIdentificaitonRestriction) {
  const { t } = useTranslation();
  const [customerIdentificationRestriction, setCustomerIdentificationRestriction] =
    useState<ICustomerIdentificationRestrictionObject>();
  useEffect(() => {
    if (!matterId) {
      return;
    }

    if (!parameters?.parameters.featuresInUseParameters.customerIdentificationInUse) {
      setCustomerIdentificationRestriction({
        matterId: matterId,
        customerIdentificationRestrictionType: AlertType.NOALERT,
      });
      return;
    }

    if (!matterCustomerIdentificationStatus) {
      if (setFetchMatter) {
        setFetchMatter(true);
      }
    }

    if (!customerIdentificationParametersAlertType || !matterCustomerIdentificationStatus) {
      return;
    }

    if (
      matterCustomerIdentificationStatus === CustomerIdentificationStatus.NOT_REQUIRED ||
      matterCustomerIdentificationStatus === CustomerIdentificationStatus.IDENTIFIED ||
      customerIdentificationParametersAlertType === AlertType.NOALERT
    ) {
      setCustomerIdentificationRestriction({
        matterId: matterId,
        customerIdentificationRestrictionType: AlertType.NOALERT,
      });
    } else if (customerIdentificationParametersAlertType === AlertType.WARNING) {
      setCustomerIdentificationRestriction({
        matterId: matterId,
        customerIdentificationRestrictionType: AlertType.WARNING,
        message: t('transaction:restrictions.requiredCustomerIdentificationsAreNotCompleted') ?? '',
      });
    } else if (customerIdentificationParametersAlertType === AlertType.ERROR) {
      setCustomerIdentificationRestriction({
        matterId: matterId,
        customerIdentificationRestrictionType: AlertType.ERROR,
        message: t('transaction:restrictions.requiredCustomerIdentificationsAreNotCompleted') ?? '',
      });
    }
  }, [customerIdentificationParametersAlertType, matterCustomerIdentificationStatus, matterId]);

  return { customerIdentificationRestriction };
}
